<script setup lang="ts">
import AppNavbarClock from "@/App/components/AppNavbar/AppNavbarClock.vue";
import UpdateAvailable from "@/App/components/AppNavbar/UpdateAvailable.vue";
import { RouteName } from "@/App/router/routeName";
</script>

<template>
  <UpdateAvailable></UpdateAvailable>

  <nav class="app-navbar navbar navbar-expand">
    <div class="app-navbar__container main-content">
      <RouterLink class="brand" :to="RouteName.login">
        <div class="logo">
          <img alt="TigerConnect" src="@/App/assets/logo.png" title="TigerConnect" class="py-2" />
        </div>
      </RouterLink>

      <app-navbar-clock />
    </div>
  </nav>
</template>

<style>
.app-navbar {
  background: #18159d;
  color: var(--bs-gray-500);
  height: 3.5rem;
}

.app-navbar__container {
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
}

.app-navbar img {
  height: 3.4rem;
  width: auto;
}

.brand {
  text-decoration: none;
}
</style>
